class DeleteAiModel {
	constructor(
		public readonly accountId: number,
		public readonly modelId: number,
	) {
		Object.freeze(this);
	}
}

export default DeleteAiModel;
